export const handleSetVerticalPosition = (quill, range) => {
  if (!quill) return 0;

  let index = 0; 

  if (range && range.length > 0) {
    const baseIndex = range.index;

    const [line, offset] = quill.getLine(baseIndex) || [];

    if (line) {
      index = baseIndex - offset;
    }
  }

  const bounds = quill.getBounds(index);

  const editorContent = quill.root;
  const editorWrapper = editorContent.closest('.ql-container');

  const contentRect = editorContent.getBoundingClientRect();
  const wrapperRect = editorWrapper.getBoundingClientRect();

  const distanceFromTop = bounds.top + (contentRect.top - wrapperRect.top);

  return distanceFromTop - 7;
};